import { Card } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // importa y registra el locale
import { useEffect } from 'react';
import { GraficoBar } from './GraficoBar';
import { useProtesisTramitesPorAuditorBarraApilada } from '../hooks';
dayjs.locale('es'); // activa el idioma español

export const IniciadoAutorizadoAnualBarraApilada = ({ date, data }) => {
  const { datosAnualesBarrasApiladas, getDatosAnualesBarrasApiladas } =
    useProtesisTramitesPorAuditorBarraApilada({
      anualList: data,
      top: 10,
    });

  useEffect(() => {
    if (data && data.length > 0) {
      getDatosAnualesBarrasApiladas();
    }
  }, [data]);

  return (
    <>
      <Card
        sx={{ px: 3, py: 3, width: '100%', maxWidth: '800px', height: { xs: '500px', sm: '100%' } }}
      >
        <GraficoBar
          labels={datosAnualesBarrasApiladas?.labels}
          datasets={datosAnualesBarrasApiladas?.datasets}
          options={{
            plugins: {
              title: {
                text: 'Trámites por mes (' + dayjs(date).format('YYYY') + ')',
                display: true,
              },
              legend: { position: 'bottom' },
            },
          }}
        />
      </Card>
    </>
  );
};
